import React from "react";
import { Link } from 'react-router-dom';
import './ServiceSectionEnhanced.css';
import orthopedicImg from '../../images/Treatments/orthopedic.jpg';
import neurologicalImg from '../../images/Treatments/neurological.jpg';
import wellnessImg from '../../images/Treatments/wellness.jpg';
import specializedImg from '../../images/Treatments/specialized.jpg';
import headacheImg from '../../images/headache.jpg';

const ServiceSectionEnhanced = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    
    const treatmentCategories = [
        {
            image: orthopedicImg,
            alt: "Orthopedic & Performance Medicine",
            title: "Orthopedic & Performance Medicine",
            treatments: [
                "Joint Pain & Arthritis Solutions",
                "Athletic Performance & Sports Medicine"
            ]
        },
        {
            image: neurologicalImg,
            alt: "Neurological & Cognitive Health",
            title: "Neurological & Cognitive Health",
            treatments: [
                "Chronic Pain Management",
                "Neurological Recovery & Support",
                "Neurodegenerative & Dementia Therapy"
            ]
        },
        {
            image: wellnessImg,
            alt: "Wellness & Regenerative Enhancement",
            title: "Wellness & Regenerative Enhancement",
            treatments: [
                "Sexual Wellness & Performance",
                "Anti-Aging & Longevity",
                "Men's Health"
            ]
        },
        {
            image: specializedImg,
            alt: "Specialized Therapies & Developmental Support",
            title: "Specialized Therapies",
            treatments: [
                "Developmental Disorders - Autism Spectrum",
                "MUSE Cell Therapy"
            ]
        },
        {
            image: headacheImg,
            alt: "Interventional Pain Procedures",
            title: "Interventional Pain Procedures",
            treatments: [
                "Headache",
                "Neck & Back Pain"
            ]
        }
    ];
    

    return (
        <section id="treatments-overview" className="service-section-enhanced section-padding">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Personalized Regenerative Medicine Excellence</h2>
                    <p className="section-description">
                        Amped Therapeutics leverages Florida's progressive regulatory framework to bring advanced 
                        cellular therapies directly to patients throughout the United States. Dr. Pereira combines 
                        over two decades of interventional pain management expertise with cutting-edge regenerative 
                        protocols, delivering personalized treatment plans tailored to your specific condition and health goals.
                    </p>
                </div>

                <div className="treatment-categories">
                    <div className="category-section">
                        <div className="category-image">
                            <img src={orthopedicImg} alt="Orthopedic & Performance Medicine" />
                        </div>
                        <div className="category-content">
                            <h3 className="category-title">Orthopedic & Performance Medicine</h3>
                            <ul className="treatment-list">
                                <li><span style={{color: '#666'}}>Joint Pain & Arthritis Solutions</span></li>
                                <li><span style={{color: '#666'}}>Neck and Back Pain</span></li>
                                <li><span style={{color: '#666'}}>Athletic Performance & Sports Medicine</span></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="category-section">
                        <div className="category-image">
                            <img src={neurologicalImg} alt="Neurological Recovery and Support" />
                        </div>
                        <div className="category-content">
                            <h3 className="category-title">Neurological Recovery and Support</h3>
                            <ul className="treatment-list">
                                <li><span style={{color: '#666'}}>Post-stroke, Traumatic Brain Injury</span></li>
                                <li><span style={{color: '#666'}}>Chronic Pain Management</span></li>
                                <li><span style={{color: '#666'}}>Neurological Recovery & Support</span></li>
                                <li><span style={{color: '#666'}}>Neurodegenerative & Dementia Therapy</span></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="category-section">
                        <div className="category-image">
                            <img src={wellnessImg} alt="Wellness & Regenerative Enhancement" />
                        </div>
                        <div className="category-content">
                            <h3 className="category-title">Wellness & Regenerative Enhancement</h3>
                            <ul className="treatment-list">
                                <li><span style={{color: '#666'}}>Sexual Wellness & Performance</span></li>
                                <li><span style={{color: '#666'}}>Anti-Aging & Longevity</span></li>
                                <li><span style={{color: '#666'}}>Men's Health</span></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="category-section">
                        <div className="category-image">
                            <img src={specializedImg} alt="Specialized Therapies & Developmental Support" />
                        </div>
                        <div className="category-content">
                            <h3 className="category-title">Specialized Therapies</h3>
                            <ul className="treatment-list">
                                <li><span style={{color: '#666'}}>Developmental Disorders - Autism Spectrum</span></li>
                                <li><span style={{color: '#666'}}>MUSE Cell Therapy</span></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className="category-section">
                        <div className="category-image">
                            <img src={headacheImg} alt="Interventional Pain Procedures" />
                        </div>
                        <div className="category-content">
                            <h3 className="category-title">Interventional Pain Procedures</h3>
                            <ul className="treatment-list">
                                <li><span style={{color: '#666'}}>Headache</span></li>
                                <li><span style={{color: '#666'}}>Neck & Back Pain</span></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="services-cta">
                    <p className="cta-text" style={{marginBottom: '0'}}>
                        Don't see your specific condition? <Link to="/contact" style={{color: '#1AC9A5', textDecoration: 'none', fontWeight: '600'}}>Contact us</Link> to discuss your unique needs and treatment options.
                    </p>
                </div>
            </div>
        </section>
    );
}

export default ServiceSectionEnhanced;